import React from "react";
import customSelectStyles from "./customSelectStyles";

/** Map API khách hàng (by-branch) → option cho react-select */
export const mapBranchCustomersToOptions = (items) =>
  (Array.isArray(items) ? items : []).map((c) => ({
    value: c.id,
    label: c.name,
    ward: c.ward || "",
    branchName: c.branch_name || c.branchName || "",
  }));

/**
 * Style cho dropdown KH trong modal: option nhiều dòng, không cắt chữ.
 * Luôn dùng kèm menuPortalTarget={document.body} + menuPosition="fixed".
 */
export const customerInModalSelectStyles = {
  ...customSelectStyles,
  option: (provided, state) => ({
    ...customSelectStyles.option(provided, state),
    padding: "10px 12px",
    whiteSpace: "normal",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 200000,
  }),
};

export const modalSelectPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
};

function buildGeoSubline(opt) {
  const branch = String(opt.branchName || "").trim();
  const ward = String(opt.ward || "").trim();
  if (branch && ward) return `${branch} - ${ward}`;
  if (branch) return branch;
  if (ward) return ward;
  return "";
}

/**
 * Dòng 1: TÊN KHÁCH HÀNG
 * Dòng 2: Chi nhánh - Phường / Xã (menu)
 * Value đã chọn: tên + phụ gọn
 */
export function formatCustomerOptionLabel(opt, { context }) {
  const sub = buildGeoSubline(opt);
  if (context === "value") {
    return (
      <span className="block max-w-full truncate text-sm font-medium text-gray-800">
        {opt.label}
        {sub ? (
          <span className="font-normal text-gray-500"> — {sub}</span>
        ) : null}
      </span>
    );
  }
  return (
    <div className="py-0.5 text-left">
      <div className="font-semibold uppercase leading-snug text-gray-800">
        {opt.label}
      </div>
      {sub ? (
        <div className="mt-0.5 text-[11px] leading-snug text-gray-500">{sub}</div>
      ) : null}
    </div>
  );
}

/** Tìm theo tên, chi nhánh hoặc phường/xã */
export function filterCustomerOption(option, inputValue) {
  const opt = option?.data ?? option;
  const q = String(inputValue || "").trim().toLowerCase();
  if (!q) return true;
  const label = String(opt.label || "").toLowerCase();
  const ward = String(opt.ward || "").toLowerCase();
  const branch = String(opt.branchName || "").toLowerCase();
  return label.includes(q) || ward.includes(q) || branch.includes(q);
}
